import { Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    planzones: (Identifiable<Planzone> & {
      _links: {
        [key: string]: { href: string };
      };
    })[];
  };
};

function getPlanzones(httpClient: HttpClient) {
  return () =>
    new Promise<Identifiable<Planzone>[]>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: `/planzones?sort=name,asc&size=9999`,
          method: HttpMethods.GET,
        })
        .then(({ _embedded }) => (_embedded ? _embedded.planzones : []))
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getPlanzones };
